import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from './base';
import { UserPreference } from '../models';

@Injectable({
  providedIn: 'root',
})
export class UserPreferenceService extends BaseService {
  constructor() {
    super('UserPreference');
  }

  search(search: string): Observable<UserPreference[]> {
    return this.httpService.get<UserPreference[]>(`${this.apiUrl}/Search?search=${search}`);
  }

  get(key: string): Observable<UserPreference> {
    return this.httpService.get<UserPreference>(`${this.apiUrl}?key=${key}`);
  }

  set(key: string, value: string): Observable<any> {
    const model: UserPreference = { key, value } as UserPreference;
    return this.httpService.post(this.apiUrl, model);
  }

  delete(id: string): Observable<any> {
    return this.httpService.delete(`${this.apiUrl}/${id}`);
  }
}
